var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSentConfirmation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 162,
    viewBox: "0 0 259 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.217 65.9769L70.4342 85.6659L52.0772 104.191L207.217 65.9769Z",
    fill: "#028383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M207.217 65.9769L70.4342 85.6659L52.0772 104.191L207.217 65.9769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.217 65.9769L70.4342 85.6659L76.7816 112.453L207.217 65.9769Z",
    fill: "#028383"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M207.217 65.9769L70.4342 85.6659L76.7816 112.453L207.217 65.9769Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5913 34.9653L71.6491 72.1815C71.2189 74.1969 72.5161 76.1979 74.5315 76.6281L145.379 91.7475C147.394 92.1777 149.395 90.8805 149.826 88.8651L157.768 51.6489C157.993 50.5953 157.745 49.5429 157.17 48.7179C156.643 47.9703 155.847 47.4075 154.885 47.2023L84.0379 32.0829C83.0761 31.8777 82.1191 32.0661 81.3331 32.5335C80.4721 33.0519 79.8157 33.9117 79.5913 34.9653Z",
    fill: "#028383"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.5913 34.9653L71.6491 72.1815C71.2189 74.1969 72.5161 76.1979 74.5315 76.6281L145.379 91.7475C147.394 92.1777 149.395 90.8805 149.826 88.8651L157.768 51.6489C157.993 50.5953 157.745 49.5429 157.17 48.7179C156.643 47.9703 155.847 47.4075 154.885 47.2023L84.0379 32.0829C83.0761 31.8777 82.1191 32.0661 81.3331 32.5335C80.4721 33.0519 79.8157 33.9117 79.5913 34.9653Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3333 32.5335L105.007 61.5927C109.528 67.1427 117.304 68.8017 123.697 65.5809L157.171 48.7173C156.644 47.9697 155.848 47.4069 154.886 47.2017L84.0387 32.0823C83.0757 31.8771 82.1193 32.0661 81.3333 32.5335Z",
    fill: "#028383"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.217 65.9769L94.397 92.7879L76.7816 112.453L207.217 65.9769Z",
    fill: "#028383"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M207.217 65.9769L94.397 92.7879L76.7816 112.453L207.217 65.9769Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.066 91.8311L166.369 92.3493L153.817 99.7034L153.513 99.1852L166.066 91.8311Z",
    fill: "#028383"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.967 102.431L148.271 102.949L143.755 105.595L143.452 105.077L147.967 102.431Z",
    fill: "#028383"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M207.217 65.9769L94.3975 92.7879L116.327 119.222L207.217 65.9769Z",
    fill: "#028383"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3166 128.797C56.463 128.797 56.6124 128.769 56.7576 128.712L75.138 121.435C75.7542 121.191 76.056 120.494 75.8118 119.877C75.5682 119.262 74.874 118.958 74.2542 119.203L55.8738 126.48C55.2576 126.724 54.9558 127.421 55.2 128.038C55.3866 128.509 55.8384 128.797 56.3166 128.797Z",
    fill: "#028383"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.3166 128.797C56.463 128.797 56.6124 128.769 56.7576 128.712L75.138 121.435C75.7542 121.191 76.056 120.494 75.8118 119.877C75.5682 119.262 74.874 118.958 74.2542 119.203L55.8738 126.48C55.2576 126.724 54.9558 127.421 55.2 128.038C55.3866 128.509 55.8384 128.797 56.3166 128.797Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.399 118.257C57.5454 118.257 57.6948 118.23 57.84 118.172L67.7112 114.264C68.3274 114.02 68.6292 113.323 68.385 112.706C68.142 112.09 67.4466 111.787 66.8274 112.032L56.9562 115.941C56.34 116.184 56.0382 116.881 56.2824 117.498C56.4696 117.969 56.9208 118.257 57.399 118.257Z",
    fill: "#028383"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.399 118.257C57.5454 118.257 57.6948 118.23 57.84 118.172L67.7112 114.264C68.3274 114.02 68.6292 113.323 68.385 112.706C68.142 112.09 67.4466 111.787 66.8274 112.032L56.9562 115.941C56.34 116.184 56.0382 116.881 56.2824 117.498C56.4696 117.969 56.9208 118.257 57.399 118.257Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0353 128.615C78.1817 128.615 78.3312 128.587 78.4763 128.53L96.3977 121.434C97.0139 121.191 97.3157 120.493 97.0715 119.877C96.8279 119.26 96.1313 118.959 95.5139 119.203L77.5926 126.298C76.9764 126.542 76.6745 127.239 76.9187 127.856C77.1053 128.328 77.5571 128.615 78.0353 128.615Z",
    fill: "#028383"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.0353 128.615C78.1817 128.615 78.3312 128.587 78.4763 128.53L96.3977 121.434C97.0139 121.191 97.3157 120.493 97.0715 119.877C96.8279 119.26 96.1313 118.959 95.5139 119.203L77.5926 126.298C76.9764 126.542 76.6745 127.239 76.9187 127.856C77.1053 128.328 77.5571 128.615 78.0353 128.615Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSentConfirmation);
export default __webpack_public_path__ + "static/media/messageSentConfirmation.9abf58bef8211af2bd1211258619f26a.svg";
export { ForwardRef as ReactComponent };